import React from 'react';
import PropTypes from 'prop-types';
import AutocompleteField from './AutocompleteField';

import CustomerService from 'services/CustomerService';

function CustomerAutocompleteField({ getSuggestionLabel, ...others }) {
  const handleSearchTerm = (inputValue, setIsLoading) => {
    setIsLoading(true);
    return CustomerService.search(inputValue)
      .then((data) => {
        return data;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <AutocompleteField
      onChangeSearchTerm={handleSearchTerm}
      getSuggestionLabel={getSuggestionLabel}
      placeholder="Selectione..."
      {...others}
    />
  );
}

CustomerAutocompleteField.defaultProps = {
  getSuggestionLabel: (object) => {
    return object.name;
  },
  onChange: () => {},
};
CustomerAutocompleteField.propTypes = {
  getSuggestionLabel: PropTypes.func,
  onChange: PropTypes.func,
};
export default CustomerAutocompleteField;
